module.exports = __webpack_public_path__ + "img/chip-close.7e22d9e8.svg";